import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  ProgressBar,
  Button,
  Image,
  Badge,
  Table,
  Form,
  InputGroup,
} from "react-bootstrap";
import { MdCurrencyRupee } from "react-icons/md";

import { FaCalendarAlt, FaUsers } from "react-icons/fa";
import {
  FiChevronLeft,
  FiChevronRight,
  FiPlus,
  FiCalendar,
} from "react-icons/fi";
import Kashmir from "../../assets/kashmir.jpg";
import ladakh from "../../assets/ladakh.jpg";
import munnar from "../../assets/munnar.jpg";
import Rishikesh from "../../assets/Rishikesh.jpg";
import Ooty from "../../assets/Ooty.jpg";
import Andaman from "../../assets/Andaman Islands.jpg";
import darjee from "../../assets/Darjeeling.jpg";
import udaipur from "../../assets/Udaipur.jpg";
import manali from "../../assets/manali.jpg";
import jaipur from "../../assets/Jaipur.jpg";
import Goa from "../../assets/Goa.jpg";
import { FaPlane } from "react-icons/fa";



import { BsThreeDots } from "react-icons/bs";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ReferenceLine,
  CartesianGrid,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaSyncAlt, FaStar } from "react-icons/fa";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MdPayment, MdCancel } from "react-icons/md";

export default function Dashboard() {
  const navigate = useNavigate();

  const revenueData = [
    { day: "Sun", value: 380 },
    { day: "Mon", value: 420 },
    { day: "Tue", value: 280 },
    { day: "Wed", value: 635 },
    { day: "Thu", value: 430 },
    { day: "Fri", value: 590 },
    { day: "Sat", value: 540 },
  ];
  
  const destinationData = [
    { name: "Goa, India", value: 35 },
    { name: "Manali, Himachal Pradesh", value: 28 },
    { name: "Jaipur, Rajasthan", value: 22 },
    { name: "Munnar, Kerala", value: 15 },
  ];

  const COLORS = ["#0d6efd", "#5aa9ff", "#8ec5ff", "#cfe8ff"];

  const datapack = {
    stats: [
      {
        title: "Total Booking",
        value: "1,200",
        change: "+2.98%",
        positive: true,
        icon: <FaCalendarAlt size={18} />,
      },
      {
        title: "Total New Customers",
        value: "2,845",
        change: "-1.45%",
        positive: false,
        icon: <FaUsers size={18} />,
      },
      {
        title: "Total Earnings",
        value: "₹1,22,890",
        change: "+3.75%",
        positive: true,
        icon: <MdCurrencyRupee size={18} />,
      },
    ],
  };

  const data = {
    stats: [
      {
        title: "Total Booking",
        value: "1,200",
        change: "+2.98%",
        positive: true,
      },
      {
        title: "Total New Customers",
        value: "2,845",
        change: "-1.45%",
        positive: false,
      },
      {
        title: "Total Earnings",
        value: "₹12,890",
        change: "+3.75%",
        positive: true,
      },
    ],

    trips: {
      total: 1200,
      done: 620,
      booked: 465,
      canceled: 115,
    },

    packages: [
      {
        title: "Manali, Himachal Pradesh",
        days: "5 Days / 4 Nights",
        price: "₹850",
        img: manali,
      },
      {
        title: "Goa, India",
        days: "4 Days / 3 Nights",
        price: "₹650",
        img: Goa,
      },
      {
        title: "Jaipur, Rajasthan",
        days: "6 Days / 5 Nights",
        price: "₹900",
        img: jaipur,
      },
    ],

    upcoming: [
      {
        title: "Kashmir, India",
        date: "5 – 10 July",
        img: Kashmir,
      },
      {
        title: "Leh Ladakh, India",
        date: "12 – 19 July",
        img: ladakh,
      },
      {
        title: "Munnar, Kerala",
        date: "15 – 24 July",
        img: munnar,
      },
      {
        title: "Rishikesh, Uttarakhand",
        date: "5 – 10 July",
        img: Rishikesh,
      },
      {
        title: "Ooty, Tamil Nadu",
        date: "12 – 19 July",
        img: Ooty,
      },
      {
        title: "Andaman Islands",
        date: "15 – 24 July",
        img: Andaman,
      },
      {
        title: "Darjeeling, West Bengal",
        date: "15 – 24 July",
        img: darjee,
      },
      {
        title: "Udaipur, Rajasthan",
        date: "5 – 10 July",
        img: udaipur,
      },
    ],
  };

  const bookingData = [
    {
      id: 101,
      name: "Arjun Sharma",
      package: "Goa Beach Holiday",
      duration: "5D4N",
      date: "Jul 10 - Jul 14",
      price: "₹1,850",
      status: "Confirmed",
    },
    {
      id: 102,
      name: "Priya Reddy",
      package: "Manali Mountain Trip",
      duration: "7D6N",
      date: "Jul 12 - Jul 18",
      price: "₹2,950",
      status: "Pending",
    },
    {
      id: 103,
      name: "Rahul Verma",
      package: "Kashmir Valley Tour",
      duration: "6D5N",
      date: "Jul 15 - Jul 20",
      price: "₹2,400",
      status: "Confirmed",
    },
    {
      id: 104,
      name: "Sneha Nair",
      package: "Andaman Island Escape",
      duration: "4D3N",
      date: "Jul 18 - Jul 21",
      price: "₹3,100",
      status: "Cancelled",
    },
    {
      id: 105,
      name: "Vikram Patel",
      package: "Jaipur Heritage Trip",
      duration: "5D4N",
      date: "Jul 20 - Jul 24",
      price: "₹2,200",
      status: "Confirmed",
    },
    {
      id: 106,
      name: "Kiran Kumar",
      package: "Ooty Hill Station Tour",
      duration: "7D6N",
      date: "Jul 12 - Jul 18",
      price: "₹2,950",
      status: "Pending",
    },
    {
      id: 107,
      name: "Ananya Gupta",
      package: "Munnar Tea Valley Trip",
      duration: "7D6N",
      date: "Jul 12 - Jul 18",
      price: "₹2,950",
      status: "Pending",
    },
  ];

  // calenders <----

  const today = new Date();
  const [currentDate, setCurrentDate] = useState(
    new Date(today.getFullYear(), today.getMonth(), 1),
  );

  const selectedDates = [12, 19];
  const rangeStart = 13;
  const rangeEnd = 18;

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();

  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();

  const generateCalendar = () => {
    let days = [];

    for (let i = firstDayOfMonth; i > 0; i--) {
      days.push({
        date: daysInPrevMonth - i + 1,
        current: false,
      });
    }

    // Current -> Month <----
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        date: i,
        current: true,
      });
    }

    // Next - > Month Head --- >
    while (days.length % 7 !== 0) {
      days.push({
        date: days.length,
        current: false,
      });
    }

    return days;
  };

  const calendarDays = generateCalendar();

  const changeMonth = (direction) => {
    setCurrentDate(new Date(year, month + direction, 1));
  };

  return (
    <Container fluid className="p-4 bg-light">
      <Row>
        <Col lg={8}>
          <Row>
            {datapack.stats.map((item, i) => (
              <Col md={4} key={i} className="mb-4">
                <div
                  className="p-3 rounded-4"
                  style={{ backgroundColor: "#eaf3fb" }}
                >
                  {/* FIRST ROW → Icon + Title */}
                  <div className="d-flex align-items-center mb-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3 me-2"
                      style={{
                        width: "42px",
                        height: "42px",
                        backgroundColor: "#d7e8f8",
                        color: "#0d6efd",
                      }}
                    >
                      {item.icon}
                    </div>

                    <div className="text-muted fw-semibold">{item.title}</div>
                  </div>

                  {/* SECOND ROW → Value + Badge */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="fs-4 fw-bold text-dark">{item.value}</div>

                    <span
                      className={`px-3 py-1 rounded-3 fw-semibold small ${item.positive
                        ? "bg-success-subtle text-success"
                        : "bg-danger-subtle text-danger"
                        }`}
                    >
                      {item.change}
                    </span>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Revenue <-> Destinations */}
          <Row className="mb-4">
            <Col lg={7} className="mb-4 mb-lg-0">
              <Card className="border-0 shadow-sm rounded-4 p-3 h-100">
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-semibold mb-0">Revenue Overview</h6>
                  <button
                    className="btn btn-sm rounded-3"
                    style={{ background: "#e7f1ff", color: "#0d6efd" }}
                  >
                    Weekly
                  </button>
                </div>

                <div style={{ width: "100%", height: 260 }}>
                  <ResponsiveContainer>
                    <LineChart
                      data={revenueData}
                      margin={{ top: 20, right: 20, left: -10, bottom: 0 }}
                    >
                      <CartesianGrid stroke="#eef2f7" vertical={false} />

                      <XAxis
                        dataKey="day"
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 12 }}
                      />

                      <YAxis
                        axisLine={false}
                        tickLine={false}
                        tick={{ fontSize: 12 }}
                        domain={[0, 800]}
                        ticks={[0, 200, 400, 600, 800]}
                      />

                      {/* Vertical dotted line on Wed */}
                      <ReferenceLine
                        x="Wed"
                        stroke="#0d6efd"
                        strokeDasharray="3 3"
                      />

                      <Tooltip content={<CustomTooltip />} />

                      <Line
                        type="monotone"
                        dataKey="value"
                        stroke="#0d6efd"
                        strokeWidth={3}
                        dot={false}
                        activeDot={{
                          r: 6,
                          fill: "#0d6efd",
                          stroke: "#fff",
                          strokeWidth: 3,
                        }}
                        animationDuration={1200}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </Col>

            <Col lg={5}>
              <Card className="border-0 shadow-sm rounded-4 p-3 h-100">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h6 className="fw-semibold mb-0">Top Destinations</h6>
                  <Button
                    size="sm"
                    className="rounded-3"
                    style={{
                      background: "#e7f1ff",
                      color: "#0d6efd",
                      border: "none",
                    }}
                  >
                    This Month
                  </Button>
                </div>

                <Row className="align-items-center">
                  <Col xs={12} className="d-flex justify-content-center mb-4">
                    <div style={{ width: "100%", height: 220 }}>
                      <ResponsiveContainer>
                        <PieChart>
                          <Pie
                            data={destinationData}
                            cx="50%"
                            cy="50%"
                            innerRadius={55}
                            outerRadius={80}
                            paddingAngle={3}
                            dataKey="value"
                            animationDuration={800}
                          >
                            {destinationData.map((entry, index) => (
                              <Cell key={index} fill={COLORS[index]} />
                            ))}
                          </Pie>

                          <Tooltip
                            formatter={(value) => [`${value}%`, "Visitors"]}
                            contentStyle={{
                              borderRadius: "10px",
                              border: "none",
                              boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
                            }}
                          />
                        </PieChart>
                      </ResponsiveContainer>
                    </div>
                  </Col>

                  <Col xs={12}>
                    <Row>
                      {destinationData.map((item, index) => (
                        <Col xs={12} sm={6} key={index} className="mb-3">
                          <div className="d-flex align-items-start">
                            {/* Color Dot */}
                            <div
                              className="me-2 mt-1"
                              style={{
                                width: 10,
                                height: 10,
                                borderRadius: "50%",
                                backgroundColor: COLORS[index],
                              }}
                            />

                            {/* Text */}
                            <div>
                              <div className="fw-semibold small">
                                {item.name} ({item.value}%)
                              </div>
                              <div className="text-muted small">
                                2,458 Participants
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <Card className="border-0 shadow-sm rounded-4 p-4 mb-4">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="d-flex align-items-center justify-content-center rounded-3"
                      style={{
                        width: 50,
                        height: 50,
                        background: "#e7f1ff",
                      }}
                    >
                      <FaPlane className="text-primary" />
                    </div>
                    <div>
                      <small className="text-muted">Total Trips</small>
                      <h4 className="fw-bold mb-0">{data.trips.total}</h4>
                    </div>
                  </div>
                </div>

                {/* Progress Info */}
                <div className="d-flex gap-4 mt-3 small">
                  <span className="text-success">● Done {data.trips.done}</span>
                  <span className="text-primary">
                    ● Booked {data.trips.booked}
                  </span>
                  <span className="text-danger">
                    ● Canceled {data.trips.canceled}
                  </span>
                </div>

                <ProgressBar
                  className="mt-3 rounded-pill"
                  style={{ height: "8px" }}
                >
                  <ProgressBar
                    now={(data.trips.done / data.trips.total) * 100}
                    variant="success"
                    key={1}
                  />
                  <ProgressBar
                    now={(data.trips.booked / data.trips.total) * 100}
                    variant="primary"
                    key={2}
                  />
                  <ProgressBar
                    now={(data.trips.canceled / data.trips.total) * 100}
                    variant="danger"
                    key={3}
                  />
                </ProgressBar>
              </Card>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="fw-semibold mb-0">Travel Packages</h5>
                <Button variant="light" size="sm">
                  View All
                </Button>
              </div>

              <Row>
                {data.packages.map((pkg, i) => (
                  <Col lg={4} md={12} sm={12} key={i} className="mb-4">
                    <Card className="border-0 shadow-sm rounded-4 overflow-hidden h-100">
                      {/* Image Section */}
                      <div className="position-relative">
                        <Card.Img
                          src={pkg.img}
                          style={{ height: 160, objectFit: "cover" }}
                        />
                        <Badge
                          bg="light"
                          text="dark"
                          className="position-absolute top-0 start-0 m-3 px-3 py-2 rounded-pill"
                        >
                          {pkg.tag}
                        </Badge>
                      </div>

                      <Card.Body className="d-flex flex-column">
                        <h6 className="fw-semibold fs-6 fs-md-5">
                          {pkg.title}
                        </h6>

                        <p
                          className="text-muted small mb-2"
                          style={{ fontSize: "10px" }}
                        >
                          {pkg.days}
                        </p>

                        <div className="mt-auto">
                          <h6 className="fw-bold text-primary mb-1 fs-6 fs-md-5">
                            {pkg.price}
                          </h6>

                          <div className="d-flex justify-content-between align-items-center">
                            <small
                              className="text-muted small"
                              style={{ fontSize: "10px" }}
                            >
                              per person
                            </small>

                            <Button
                              size="sm"
                              className="rounded-pill px-2 py-1 small"
                              style={{ fontSize: "6px" }}
                            >
                              See Detail
                            </Button>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>

          <Row className="mt-1">
            <Col lg={12} md={12} className="mb-2">
              <Card className="shadow-sm border-0 rounded-4">
                <Card.Body>
                  {/* Header */}
                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                    <h5 className="fw-semibold mb-0">Recent Bookings</h5>

                    <div className="d-flex gap-2">
                      <InputGroup>
                        <InputGroup.Text className="bg-light border-0">
                          <FaSearch />
                        </InputGroup.Text>
                        <Form.Control
                          placeholder="Search anything"
                          className="bg-light border-0"
                        />
                      </InputGroup>
                      <Button variant="primary" className="rounded-3 px-3">
                        View All
                      </Button>
                    </div>
                  </div>

                  {/* Table */}
                  <div className="table-responsive">
                    <Table hover className="align-middle mb-0">
                      <thead className="table-light">
                        <tr>
                          <th>Name</th>
                          <th>Package</th>
                          <th>Duration</th>
                          <th>Date</th>
                          <th>Price</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {bookingData.map((item) => (
                          <tr key={item.id}>
                            <td>{item.name}</td>
                            <td>{item.package}</td>
                            <td>{item.duration}</td>
                            <td>{item.date}</td>
                            <td>{item.price}</td>
                            <td>{item.status}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>

        <Col
          lg={4}
          className="mt-4 mt-lg-0"
          onClick={() => navigate("/admin/calendar")}
        >
          <Card className="border-0 shadow-sm rounded-4 p-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="fw-semibold mb-0">
                {currentDate.toLocaleString("default", {
                  month: "long",
                  year: "numeric",
                })}
              </h6>

              <div className="d-flex gap-2">
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => changeMonth(-1)}
                >
                  <FiChevronLeft />
                </Button>
                <Button
                  size="sm"
                  variant="light"
                  onClick={() => changeMonth(1)}
                >
                  <FiChevronRight />
                </Button>
              </div>
            </div>

            <div
              className="d-grid text-center mb-2"
              style={{ gridTemplateColumns: "repeat(7, 1fr)" }}
            >
              {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map(
                (day, i) => (
                  <div key={i} className="text-muted small fw-medium">
                    {day}
                  </div>
                ),
              )}
            </div>

            {/* Dates */}
            <div
              className="d-grid text-center"
              style={{
                gridTemplateColumns: "repeat(7, 1fr)",
                gap: "8px",
              }}
            >
              {calendarDays.map((item, i) => {
                const isToday =
                  item.date === today.getDate() &&
                  month === today.getMonth() &&
                  year === today.getFullYear() &&
                  item.current;

                const isActive = selectedDates.includes(item.date);
                const isRange =
                  item.date >= rangeStart && item.date <= rangeEnd;

                return (
                  <div
                    key={i}
                    className="py-2 rounded-3"
                    style={{
                      backgroundColor: isActive
                        ? "#0d6efd"
                        : isRange
                          ? "#dbeafe"
                          : "transparent",
                      color: !item.current
                        ? "#c0c4cc"
                        : isActive
                          ? "#fff"
                          : isToday
                            ? "#0d6efd"
                            : "#495057",
                      fontWeight: isActive || isToday ? "600" : "500",
                      border: isToday ? "2px solid #0d6efd" : "none",
                      fontSize: "14px",
                      cursor: "pointer",
                    }}
                  >
                    {item.date}
                  </div>
                );
              })}
            </div>

            <Card className="border-0  rounded-4 p-1  my-4">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6 className="fw-semibold mb-0">Upcoming Trips</h6>
                <Button
                  size="sm"
                  className="rounded-3 my-4"
                  style={{ background: "#0d6efd", border: "none" }}
                >
                  <FiPlus color="#fff" />
                </Button>
              </div>

              {data.upcoming.map((trip, i) => (
                <div
                  key={i}
                  className={`d-flex align-items-center p-2 rounded-4 mb-3 ${i === 1 ? "bg-primary-subtle" : ""
                    }`}
                >
                  <Image
                    src={trip.img}
                    width={60}
                    height={60}
                    rounded
                    style={{ objectFit: "cover" }}
                  />

                  <div className="ms-3 flex-grow-1">
                    <span className="badge bg-light text-primary small mb-1">
                      {trip.tag || "Romantic Getaway"}
                    </span>

                    <div className="fw-semibold">{trip.title}</div>

                    <div className="text-muted small d-flex align-items-center mt-1">
                      <FiCalendar className="me-1" />
                      {trip.date}
                    </div>
                  </div>
                </div>
              ))}
            </Card>
          </Card>

          <Col lg={12} md={12}>
            <Card className="shadow-sm border-0 rounded-4 my-4">
              <Card.Body>
                {/* Header */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <h5 className="fw-semibold mb-0">Recent Activity</h5>
                  <BsThreeDotsVertical />
                </div>

                <p className="text-muted small fw-semibold">Today</p>

                {/* Activity Items */}
                <div className="d-flex mb-3">
                  <div className="me-3 text-primary">
                    <FaSyncAlt size={18} />
                  </div>
                  <div>
                    <div className="fw-semibold small">
                      Alberto Cortez updated his profile and added a new payment
                      method
                    </div>
                    <div className="text-muted small">9:30 AM</div>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div className="me-3 text-primary">
                    <FaCalendarAlt size={18} />
                  </div>
                  <div>
                    <div className="fw-semibold small">
                      Camellia Swan booked the Venice Dreams package for June
                      25, 2024.
                    </div>
                    <div className="text-muted small">10:00 AM</div>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div className="me-3 text-primary">
                    <MdPayment size={20} />
                  </div>
                  <div>
                    <div className="fw-semibold small">
                      Payment was processed for Ludwig Contessa’s Alpine Escape
                      package.
                    </div>
                    <div className="text-muted small">11:15 AM</div>
                  </div>
                </div>

                <div className="d-flex mb-3">
                  <div className="me-3 text-danger">
                    <MdCancel size={20} />
                  </div>
                  <div>
                    <div className="fw-semibold small">
                      Armina Raul Meyes canceled her Caribbean Cruise package.
                    </div>
                    <div className="text-muted small">12:45 PM</div>
                  </div>
                </div>

                <div className="d-flex">
                  <div className="me-3 text-primary">
                    <FaStar size={18} />
                  </div>
                  <div>
                    <div className="fw-semibold small">
                      Lydia Billings submitted a review for her recent package.
                    </div>
                    <div className="text-muted small">2:30 PM</div>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Col>
      </Row>
    </Container>
  );
}

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "#eef2f6",
          padding: "8px 12px",
          borderRadius: "10px",
          boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <div style={{ fontWeight: 600 }}>${payload[0].value}</div>
        <div style={{ fontSize: "12px", color: "#6c757d" }}>12 Jul 28</div>
      </div>
    );
  }
  return null;
};
